import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { database, ref, get } from "../../../firebase";

const CallAcceptfile = () => {
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [firebaseToken, setFirebaseToken] = useState("");
  const [supportEnggCallData, setSupportEnggCallData] = useState({
    UserId: localStorage.getItem("UserID") || "",
    OutletId: "",
    OutletName: "", 
    Call_Id: "",
    AdminToSupportEngg_id: id,
    SupportEnggName: "",
    SupportEnggMobileNo: "",
    SupportEnggCall_Status: "",
    textAreaReasons: "",
    howtosolveinformation: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_API}AdminToSupportEngg/AdminToSupportEngg/${id}`
        );

        if (response.data.success && response.data.data) {
          const data = response.data.data;
          const { OutletId, Call_Id, Call_Status, UserId } = data;

          setSupportEnggCallData({
            ...supportEnggCallData,
            OutletId: OutletId._id,
            OutletName: OutletId.Outlet_name, 
            Call_Id: Call_Id._id,
            SupportEnggName: UserId.User_Name,
            SupportEnggMobileNo: UserId.Mobile_No,
            SupportEnggCall_Status: Call_Status || "",
          });

         
          fetchFirebaseUsers(Call_Id.UserId);
        } else {
          console.error("Data not found:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [id]);

  const handleSubmitSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_API}SupportEngg`,
        supportEnggCallData
      );
      console.log("POST request successful:", response.data);
      
      
      setSupportEnggCallData({
        UserId: localStorage.getItem("UserID") || "",
        OutletId: "",
        OutletName: "", 
        AdminToSupportEngg_id: id,
        Call_Id: "",
        SupportEnggName: "",
        SupportEnggMobileNo: "",
        SupportEnggCall_Status: "",
        textAreaReasons: "",
        howtosolveinformation: "",
      });

     
      if (supportEnggCallData.SupportEnggCall_Status === "Call Accepted" ||
          supportEnggCallData.SupportEnggCall_Status === "Call Resolve") {
        await SendNotificationProcess();
      }

      navigate("/SuppEngCallsShow");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setSupportEnggCallData({
      ...supportEnggCallData,
      [name]: value,
    });
  };

  const fetchFirebaseUsers = async (callUserId) => {
    try {
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);

      if (snapshot.exists()) {
        const users = snapshot.val();
        const filteredUsers = Object.values(users).filter(user => user.UserRoleId === 2);

        const selectedUser = filteredUsers.find(user => user.UserId === callUserId);
        if (selectedUser) {
          console.log("Selected Firebase User:", selectedUser); 
          setFirebaseToken(selectedUser.firebaseToken);
        } else {
          console.log("Selected user not found in Firebase.");
        }
      } else {
        console.log("No users found.");
      }
    } catch (error) {
      console.error("Error fetching users from Firebase:", error);
    }
  };

  const SendNotificationProcess = async () => {
    try {
      if (!firebaseToken) {
        console.error("Firebase token is not set");
        return;
      }

      let title = "";
      let body = "";

      switch (supportEnggCallData.SupportEnggCall_Status) {
        case "Call Accepted":
          title = `Restaurant: ${supportEnggCallData.OutletName} Call Accepted`; 
          body = `Support Engg: ${supportEnggCallData.SupportEnggName} Mobile No: ${supportEnggCallData.SupportEnggMobileNo}`;
          break;
        case "Call Resolve":
          title = `Restaurant: ${supportEnggCallData.OutletName} Call Resolve`; 
          body = `Support Engg: ${supportEnggCallData.SupportEnggName} Mobile No: ${supportEnggCallData.SupportEnggMobileNo} Solve Problem : ${supportEnggCallData.howtosolveinformation}`;
          break;
        default:
          console.error("Unsupported call status for notification.");
          return;
      }

      const imageURL = "/static/media/NavbarLogo.7aff387d8291bb227a01.png";

      const response = await axios.post(`${process.env.REACT_APP_SERVER_API}/sendnotification`, {
        token: firebaseToken,
        title: title,
        body: body,
        image: imageURL
      });

      console.log("Notification sent successfully:", response.data);
    } catch (error) {
      console.error("Failed to send notification:", error);
    }
  };

   

  return (
    <div className="container mt-5">
      <div className="row d-flex justify-content-center">
        <div className="col-md-4 shadow-lg p-3 mb-5 bg-body rounded">
          <form onSubmit={handleSubmitSubmit}>
            <div className="form-floating mb-3">
              <select
                className="form-select"
                name="SupportEnggCall_Status"
                value={supportEnggCallData.SupportEnggCall_Status}
                onChange={handleOnChange}
                aria-label="Select Call Status"
                required
              >
                <option value="">Select Status</option>
                <option value="Call Accepted">Call Accepted</option>
                <option value="Call Not Accepted">Call Not Accepted</option>
                <option value="Call Resolve">Call Resolve</option>
              </select>
              <label htmlFor="SupportEnggCall_Status">Select Call Status</label>
            </div>
            {supportEnggCallData.SupportEnggCall_Status === "Call Not Accepted" && (
              <div className="form-floating">
                <textarea
                  className="form-control"
                  id="textAreaReasons"
                  name="textAreaReasons"
                  value={supportEnggCallData.textAreaReasons}
                  onChange={handleOnChange}
                  required
                ></textarea>
                <label htmlFor="textAreaReasons">Reasons Why Not Accept Call</label>
              </div>
            )}
            {supportEnggCallData.SupportEnggCall_Status === "Call Resolve" && (
              <div className="form-floating">
                <textarea
                  className="form-control"
                  id="howtosolveinformation"
                  name="howtosolveinformation"
                  value={supportEnggCallData.howtosolveinformation}
                  onChange={handleOnChange}
                  required
                ></textarea>
                <label htmlFor="howtosolveinformation">How To Solve Information</label>
              </div>
            )}
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CallAcceptfile;
